import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import global from './global'
import process from './process'
import news from './news'
import works from './works'
import interview from './interview'
import guide from './guide'
import register from './register'
import login from './login'
import layout from './layout'
import members from './members'
import entries from './entries'
import password from './password'
import competitor from './competitor'

const cn = {
  global,
  process,
  news,
  works,
  interview,
  guide,
  register,
  login,
  layout,
  members,
  entries,
  password,
  competitor,
  ...zhLocale
}

export default cn
